/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CapNames } from '../CapNames';
import { Materials } from '../../materials/Materials';
import { Orientation } from '../Orientation';
import { Solids } from '../../geometries/Solids';
import { Line, Mesh, Points } from 'three';
/**
 * types of generic solids
 */
export var GenericSolidType;
(function (GenericSolidType) {
    GenericSolidType["spaced"] = "spaced";
    GenericSolidType["dots"] = "dots";
    GenericSolidType["lines"] = "lines";
    GenericSolidType["extruded"] = "extruded";
    GenericSolidType["surface"] = "surface";
})(GenericSolidType || (GenericSolidType = {}));
/**
 * Capability to draw GenericSolids
 */
export class GenericSolidCap {
    static handleGenericSolid(payload, material) {
        const shape = Solids.shapeFromSVGPath(payload.svgpath);
        let obj;
        let spaced = false;
        switch (payload.type) {
            case GenericSolidType.lines:
                const geo1 = Solids.createPointsFromShape(shape, false);
                obj = new Line(geo1, material);
                break;
            case GenericSolidType.extruded:
                const geo2 = Solids.createExtrudedObjectFromShape(shape, payload.extrudeSettings);
                obj = new Mesh(geo2, material);
                break;
            case GenericSolidType.surface:
                const geo3 = Solids.createSurfaceFromShape(shape);
                obj = new Mesh(geo3, material);
                break;
            case GenericSolidType.spaced:
                spaced = true;
            case GenericSolidType.dots:
            default:
                const geo4 = Solids.createPointsFromShape(shape, spaced, payload.divisions ? payload.divisions : 25);
                obj = new Points(geo4);
                break;
        }
        return obj;
    }
    getName() {
        return CapNames.GENERICSOLID;
    }
    call(objectIn, sceneIn) {
        const payload = objectIn.payload;
        if (!!payload && !!payload.svgpath && !!payload.type) {
            const _material = !!objectIn.materials && objectIn.materials.length === 1 ? objectIn.materials[0] : undefined;
            const material = Materials.create(_material, sceneIn);
            if (!!material) {
                const solid = GenericSolidCap.handleGenericSolid(objectIn.payload, material);
                if (!!solid) {
                    solid.name = objectIn.name;
                    Orientation.set(solid, objectIn);
                    sceneIn.set(solid);
                    sceneIn.setTag(objectIn.tag, solid);
                    return true;
                }
            }
        }
        return false;
    }
}
//# sourceMappingURL=GenericSolidCap.js.map